export interface ShortcutType {
    [key: string]: (event: KeyboardEvent) => void
}

export enum ShortcutsCategories {
    GLOBAL = 'GLOBAL',
    OPTION_CHAIN = 'OPTION_CHAIN',
    CHART = 'CHART',
    ALERT_DIALOG = 'ALERT_DIALOG',
    INDICATOR_DIALOG = 'INDICATOR_DIALOG',
    MULTI_PANE_MENU = 'MULTI_PANE_MENU',
    SECURITY_SEARCH = 'SECURITY_SEARCH',
    QUICK_SEARCH="QUICK_SEARCH",
    CUSTOM_TIME_INTERVAL = 'CUSTOM_TIME_INTERVAL',
    CHART_DURATION = 'CHART_DURATION',
    ADD_TO_WATCHLIST = 'ADD_TO_WATCHLIST',
    CHART_REPLAY = 'CHART_REPLAY',
    CHART_TYPE = 'CHART_TYPE',
    SCREENER = 'SCREENER',
    CHART_SETTINGS = 'CHART_SETTINGS',
    SAVE_MENU = 'SAVE_MENU',
    QUICK_WIDGETS = 'QUICK_WIDGETS'
}

export enum SpecKeys {
    CONTROL = 'Control',
    ALT = 'Alt',
    META = 'Meta',
    SHIFT = 'Shift',
    COMMAND="Command"
}

export const KeyCodeToKey: Record<string, string> = {
    Backspace: 'Backspace',
    Tab: 'Tab',
    Enter: 'Enter',
    Shift: 'Shift',
    Control: 'Control',
    Alt: 'Alt',
    Pause: 'Pause',
    CapsLock: 'CapsLock',
    Escape: 'Escape',
    Space: 'Space',
    PageUp: 'PageUp',
    PageDown: 'PageDown',
    End: 'End',
    Home: 'Home',
    ArrowLeft: 'ArrowLeft',
    ArrowUp: 'ArrowUp',
    ArrowRight: 'ArrowRight',
    ArrowDown: 'ArrowDown',
    PrintScreen: 'PrintScreen',
    Insert: 'Insert',
    Delete: 'Delete',
    Digit0: '0',
    Digit1: '1',
    Digit2: '2',
    Digit3: '3',
    Digit4: '4',
    Digit5: '5',
    Digit6: '6',
    Digit7: '7',
    Digit8: '8',
    Digit9: '9',
    KeyA: 'A',
    KeyB: 'B',
    KeyC: 'C',
    KeyD: 'D',
    KeyE: 'E',
    KeyF: 'F',
    KeyG: 'G',
    KeyH: 'H',
    KeyI: 'I',
    KeyJ: 'J',
    KeyK: 'K',
    KeyL: 'L',
    KeyM: 'M',
    KeyN: 'N',
    KeyO: 'O',
    KeyP: 'P',
    KeyQ: 'Q',
    KeyR: 'R',
    KeyS: 'S',
    KeyT: 'T',
    KeyU: 'U',
    KeyV: 'V',
    KeyW: 'W',
    KeyX: 'X',
    KeyY: 'Y',
    KeyZ: 'Z',
    MetaLeft: 'MetaLeft',
    MetaRight: 'MetaRight',
    ContextMenu: 'ContextMenu',
    Numpad0: 'Numpad0',
    Numpad1: 'Numpad1',
    Numpad2: 'Numpad2',
    Numpad3: 'Numpad3',
    Numpad4: 'Numpad4',
    Numpad5: 'Numpad5',
    Numpad6: 'Numpad6',
    Numpad7: 'Numpad7',
    Numpad8: 'Numpad8',
    Numpad9: 'Numpad9',
    NumpadMultiply: 'NumpadMultiply',
    NumpadAdd: 'NumpadAdd',
    NumpadSubtract: 'NumpadSubtract',
    NumpadDecimal: 'NumpadDecimal',
    NumpadDivide: 'NumpadDivide',
    F1: 'F1',
    F2: 'F2',
    F3: 'F3',
    F4: 'F4',
    F5: 'F5',
    F6: 'F6',
    F7: 'F7',
    F8: 'F8',
    F9: 'F9',
    F10: 'F10',
    F11: 'F11',
    F12: 'F12',
    NumLock: 'NumLock',
    ScrollLock: 'ScrollLock',
    Semicolon: ';',
    Equal: ':',
    Comma: ',',
    Minus: '-',
    Period: '.',
    Slash: '/',
    Backquote: '`',
    BracketLeft: '[',
    Backslash: '\\',
    BracketRight: ']',
    Quote: '\'',
}